import { RpcAliveData } from './rpc-alive-model';

/**
 * Rpc alive sever side handler interface.
 */
export interface RpcAliveHandler {
    handler(data: RpcAliveData): Promise<void>;
}
